import { xs_languageCode } from "..";
import { getAllAgg } from "./utils/getAllAgg";
import { filterByCustomizedState } from './utils/filterByCustomizedState';
import { getLiveAggs } from './utils/getLiveAggs';
import { getPrematchAggs } from './utils/getPrematchAggs';
import { getSplitDesc } from './utils/getSplitDesc';

export function parseFastbetData(data) {
	if (data != null) {
		data.rawDataPrematch = data.prematch != null? JSON.parse(data.prematch) : { ms: []};
		data.rawDataLive = data.live != null? JSON.parse(data.live) : {ms: []};
		
		// filter for customized state
		data.rawDataPrematch.ms = filterByCustomizedState(data.rawDataPrematch.ms);
		data.rawDataLive.ms = filterByCustomizedState(data.rawDataLive.ms);
		const parsedDataPrematch = parseMatchList(data.rawDataPrematch.ms, false);
		const matchListPrematch = parsedDataPrematch.matchList;
		const parsedDataLive = parseMatchList(data.rawDataLive.ms, true);
		let matchListLive = parsedDataLive.matchList;
		data.matchListPrematch = matchListPrematch;
		data.matchListLive = matchListLive;
		data.matchArray = parsedDataPrematch.matchArray.concat(parsedDataLive.matchArray);
		
		data.liveEventsByAlias = getMatchMapByAlias(data.rawDataLive.ms);
		data.prematchEventsByAlias = getMatchMapByAlias(data.rawDataPrematch.ms);
		// join two maps
		data.fullMatchList = {...matchListPrematch, ...matchListLive};
		return data;
	}
	return null;
}

function getMatchMapByAlias(matchResponseList) {
	let matchMap = {};
	for (let k in matchResponseList) {
		const match = matchResponseList[k];
		if (match.al != null && match.al.length > 0) {
			matchMap[match.al] = match;			
		}
	}
	return matchMap;
}

function parseMatchList(matchResponseList, isLive) {
	let matchList = {};
	let matchArray = [];
	const lookupAggregataTutte = {};
	const lookupListaAggregate = {};
	for (let k in matchResponseList) {
		let match = matchResponseList[k];
        const [team1, team2] = getSplitDesc(match.dsl[xs_languageCode]);

		if (lookupAggregataTutte[match.s] == null) {
			lookupAggregataTutte[match.s] = getAllAgg(isLive, match.s).idAggregata;
		}
		const aggregataTutte = lookupAggregataTutte[match.s];
	    
		
		if (lookupListaAggregate[match.s] == null) {
			lookupListaAggregate[match.s] = [];
			const aggMap = isLive ? getLiveAggs(match.s) : getPrematchAggs(match.s);
			for (let key in aggMap) {
				lookupListaAggregate[match.s].push(aggMap[key].idAggregata);
			}
		}
		const gruppiScommessa = lookupListaAggregate[match.s];
		
	    let parsedMatch = {
	            id: match.bid,
	            sportRef: match.s,
	            categoryRef: match.c,
	            tournamentRef: match.t,
	            pal: match.p,
	            avv: match.a,
	            desc: match.dsl[xs_languageCode],
	            team1,
	            team2,
	            sportDesc: match.dsml[xs_languageCode],
	            categoryDesc: match.dcml[xs_languageCode],
	            tournamentDesc: match.dtml[xs_languageCode],
	            alias: match.al,
	            uniqueId: `${match.s}_${match.c}_${match.t}_${match.bid}`,
	            gruppiScommessa: gruppiScommessa,
	            isLive : isLive,
	            openAggregata: aggregataTutte,
	            openMacrogruppo: match.mc,
	            timestamp : match.ts,
				plus: match.nsc
		};
		
	    matchList[match.al] = parsedMatch;
	    matchArray.push(parsedMatch);
	}
	
	return { matchList, matchArray };
}
